import DatabaseService from 'services/DatabaseService.js';
import {SET_FEATURES, CLEAR_FEATURES} from 'actions/types'; 
import {isListLoaded}  from 'reducers/features.js'


//Action Creators
export const setFeatures = (features, replace) => {
    return { type:SET_FEATURES, features:features, replace:replace };
}

export const clearFeatures = () => {
    return { type:CLEAR_FEATURES };
}



// WEBPACK FOOTER //
// ./src/actions/features.js